// extracted by mini-css-extract-plugin
export default {"user_image":"UserAccountPage_user_image__ESQbh"};